import { defaultHttpClient } from '../../../httpClient';
import type { VerificationCodeResponse } from './types';

export interface RequestAuthCodeParams {
  phone_number: string;
}

export const requestAuthCode = async (
  params: RequestAuthCodeParams,
): Promise<VerificationCodeResponse> => {
  const response = await defaultHttpClient.request<VerificationCodeResponse>({
    method: 'POST',
    url: '/api/v2/verification_code/poc/issue/',
    data: params,
  });
  return response.data;
};
